// extracted by mini-css-extract-plugin
export default {"promo":"upgradeNow_promo__AmqcV","mapxLogo":"upgradeNow_mapxLogo__4tcYc","upgradeMessage":"upgradeNow_upgradeMessage__mP-HZ","upgradeNowButton":"upgradeNow_upgradeNowButton__+OlAN"};